// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"HolderHeadline_linkWrapper__zPX9W","link":"HolderHeadline_link__oCUNF"};